import CAMCRetirementTabs from "./tabs.js";
import videoHandler from "./video.js";

$(function () {
    // Initialize retirement tabs
    const tabContainers = $(".camc-retirement-tab__container");
    if (tabContainers.length > 0) {
        tabContainers.each(function () {
            new CAMCRetirementTabs(this);
        });
    }

    // Initialize video handlers
    const videoContainers = $(".camc-retirement-trilogy__card-video");
    if (videoContainers.length > 0) {
        videoContainers.each(function () {
            new videoHandler(this);
        });
    }
});
